import Link from 'next/link';

// Mock data - API ready
const services = [
    {
        id: 1,
        name: 'Home Loans',
        description: 'Get the best home loan offers from top banks',
        icon: 'bank',
        href: '/services/home-loans',
    },
    {
        id: 2,
        name: 'Owner Plans',
        description: 'Premium features for property owners',
        icon: 'star',
        href: '/services/owner-plans',
    },
    {
        id: 3,
        name: 'Legal Services',
        description: 'Documentation and legal assistance',
        icon: 'document',
        href: '/services/legal',
    },
    {
        id: 4,
        name: 'Interior Design',
        description: 'Transform your new home beautifully',
        icon: 'paint',
        href: '/services/interior',
    },
];

const iconMap = {
    bank: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
        </svg>
    ),
    star: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
    ),
    document: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
    ),
    paint: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
    ),
};

const Services = () => {
    return (
        <section className="py-8 lg:py-12 bg-white">
            <div className="container-custom">
                {/* Section Title */}
                <div className="section-title mb-12 text-center">
                    {/* <span className="subtitle">What We Offer</span> */}
                    <h2>Our Services</h2>
                    <p className='text-center'>
                        Comprehensive solutions for all your real estate needs
                    </p>
                </div>

                {/* Services Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {services.map((service) => (
                        <div
                            key={service.id}
                            className="service-card group"
                        >
                            <div className="icon-wrapper group-hover:scale-110 transition-transform duration-300">
                                {iconMap[service.icon]}
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {service.name}
                            </h3>
                            <p className="text-gray-600 text-sm">
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
